import { Skeleton, SkeletonProps } from "@mui/material";
import React from "react";

interface IProps extends SkeletonProps {}
const FmSkeleton: React.FC<IProps> = (props) => {
    return <Skeleton {...props} />;
};

export default FmSkeleton;
